import { render, staticRenderFns } from "./Updatejourney.vue?vue&type=template&id=9252e9ec&scoped=true&"
import script from "./Updatejourney.vue?vue&type=script&lang=js&"
export * from "./Updatejourney.vue?vue&type=script&lang=js&"
import style0 from "./Updatejourney.vue?vue&type=style&index=0&id=9252e9ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9252e9ec",
  null
  
)

export default component.exports